// extracted by mini-css-extract-plugin
module.exports = {"login":"login-form_login__3iewS","links":"login-form_links__3Oik_","blueBorder":"login-form_blueBorder__1kiyx","button":"login-form_button__1KSYT"};